<template>
  <div>
    <div class="pt-6">
      <!-- <div class="py-6 text-center" v-show="!isLoaded">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div> -->
      <div class="relative">
        <div class="bg-white shadow">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <div v-if="!isLoaded"
              class="absolute inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50">
              <div class="loader"></div>
              <p class="text-gray-700 text-lg">Loading...</p>
            </div>
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ $t("messages.player.gameRecord.action") }}
                  </th>
                  <!-- <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Round Id
                  </th> -->
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.gameRecord.from") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center text-right">
                    {{ $t("messages.player.gameRecord.amount") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center text-right">
                    {{ $t("messages.player.gameRecord.validBet") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center text-right">
                    {{ $t("messages.player.gameRecord.openBalance") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center text-right">
                    {{ $t("messages.player.gameRecord.closeBalance") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.gameRecord.date") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    {{ $t("messages.player.gameRecord.source") }}
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    References
                  </th>
                  <th scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                    Note
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.id" class="hover:bg-gray-50">
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span v-if="data.action == 'DEPOSIT'"
                      class="bg-green-600 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['far', 'arrow-to-bottom']" transform="" />
                      ฝาก
                    </span>
                    <span v-else-if="data.action == 'WITHDRAW'"
                      class="bg-red-600 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['far', 'arrow-to-top']" transform="" />
                      ถอน
                    </span>
                    <span v-else-if="data.action == 'BET'"
                      class="bg-blue-400 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['fas', 'dice']" transform="" />
                      วางเดิมพัน
                    </span>
                    <span v-else-if="data.action == 'SETTLE_BET'"
                      class="bg-yellow-400 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      <font-awesome-icon class="mr-1" :icon="['fas', 'sync']" transform="" />
                      จบการเดิมพัน
                    </span>
                    <span v-else class="bg-blue-400 inline-block px-2 py-1 rounded-lg text-white text-xs">
                      {{ data.action }}
                    </span>
                  </td>
                  <!-- <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.refCode2 && data.refCode2 !== '0' ? data.refCode2 : data.refCode }}
                  </td> -->
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ data.moduleCode }}
                    <small v-if="data?.refCode2">
                      <br />
                      {{ $t("messages.player.gameRecord.gameId") }}:
                      {{ data.refCode2 }}
                    </small>
                    <small v-if="data.userdata7 || data.username">
                      <br />
                      {{ $t("messages.player.gameRecord.alias") }}:
                      {{ data.userdata7 || data.username }}
                    </small>
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.amount).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      data.validAmount
                        ? (parseFloat(data.validAmount) / 100).toLocaleString("en", {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        })
                        : "-"
                    }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.openBalance).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{
                      parseFloat(data.closeBalance).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ dayjs(data.createdAt).format("LLL") }}
                  </td>
                  <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ data.refCode5 || data.createdAt }}
                    <div v-if="checkHasGameResult(data.moduleCode)" :module-code="data.moduleCode"
                      class="text-xs text-blue-400 cursor-pointer" @click="showGameResult(data)">
                      {{ $t("messages.player.gameRecord.showGameResult") }}
                    </div>
                  </td>
                  <td class="text-left text-xs flex-col">
                    <p>Txn ID: {{ data.refCode }}</p>
                    <p v-if="data.refCode3">Round Group : {{ data.refCode3 }}</p>
                  </td>
                  <td class="text-left text-xs flex-col">
                    <p>{{ data.userdata4 || '-' }}</p>
                  </td>
                  <td class="text-xs">
                    <div class="flex-col" v-if="
                      store.state.user.permissions.includes('GAME.FORCE_STATUS') ||
                      store.state.user.permissions.includes('GAME.FORCE_UPDATE')
                    ">
                      <div>
                        <button @click="onSettleClicked(data)" class="bg-green-500 rounded p-1 text-white my-1 w-12"
                          v-if="data.action == 'BET'">
                          {{ $t("messages.player.gameRecord.resettle") }}
                        </button>
                      </div>
                      <div>
                        <button @click="onCancelBetClicked(data)" class="bg-red-500 rounded p-1 text-white my-1 w-12"
                          v-if="data.action == 'BET'">
                          {{ $t("messages.player.gameRecord.cancel") }}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination v-model:config="pageConfig" isLagacy />
        </div>
      </div>
    </div>
    <dialog-component :isOpen="isShowSettleDialog" title="ReSettle">
      <div class="row text-center m-1 text-white">
        <div class="m-3">
          <input class="rounded text-black" type="number" v-model="reSettleValue" />
        </div>
        <button class="bg-red-500 p-1 m-1 rounded" @click="closeSettleDialog">
          <p>{{ $t("messages.player.gameRecord.cancel") }}</p>
        </button>
        <button class="bg-blue-500 p-1 m-1 rounded" @click="forceSettle">
          <font-awesome-icon v-if="isLoading" class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6"
            spin />
          <p v-else>{{ $t("messages.player.gameRecord.resettle") }}</p>
        </button>
      </div>
    </dialog-component>
    <dialog-component :isOpen="isShowStatusDialog">
      <div class="p-1 m-1 text-center">
        {{ statusMessage.message }}
      </div>
      <div class="text-center">
        <button class="bg-red-500 rounded p-2 text-white" @click="isShowStatusDialog = false">
          {{ $t("messages.player.gameRecord.close") }}
        </button>
      </div>
    </dialog-component>
    <GameResultDialog v-model:show="isShowGameResultDialog" :data-rows="results" />
    <DialogComponent :title="$t('messages.player.gameRecord.error')" :isOpen="showGameResultErrorDialog"
      @close="showGameResultErrorDialog = false">
      <p class="text-center text-red-500">
        {{ resultErrorMessage }}
      </p>
    </DialogComponent>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { inject, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import Pagination from "@/components/tools/Pagination.vue";
import GameResultDialog from "@/components/dialogs/GameResultDialog.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Players", href: { name: "Player List" }, current: false }];
const rowsPerPageOption = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "30", value: 30 },
  { label: "40", value: 40 },
];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    SelectorIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    DialogComponent,
    Pagination,
    GameResultDialog,
  },
  setup() {
    const offset = ref(0);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const currentPage = ref(1);
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const fromDate = ref("");
    const toDate = ref("");
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    const isShowSettleDialog = ref(false);
    const providerList = ref([]);
    const toSettleData = ref({});
    const reSettleValue = ref();
    const isShowStatusDialog = ref(false);
    const isShowGameResultDialog = ref(false);
    const showGameResultErrorDialog = ref(false);
    const results = ref([]);
    const resultErrorMessage = ref("");
    const errorMessage = ref("");
    const statusMessage = ref({
      success: false,
      message: "",
    });
    const isLoading = ref(false);

    const pageConfig = ref({
      page: parseInt(route.query.page) || 1,
      count: 0,
      pageCount: 0,
      rowsPerPage: 10,
      dataLength: 0,
      search: "",
      // isEmitOnClick: true,
      sort: [["created_at", "DESC"]],
    });

    onMounted(() => {
      getProviderList();
      refetch();
    });

    const showGameResult = async (data) => {
      console.log({ data });
      const {
        moduleCode: providerCode,
        refCode,
        refCode2,
        refCode3,
        operatorId,
        username,
        userdata7: alias,
        refCode5: gameCode,
        createdAt,
      } = data;

      const { data: gameResult } = await axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/game/internal/view-result`, {
          operatorId,
          providerCode,
          refCode,
          refCode2,
          refCode3,
          gameCode: gameCode,
          alias,
          createdAt,
        })
        .catch(() => {
          resultErrorMessage.value = "เกมนี้ไม่รองรับการดูผลผ่านเว็บ กรุณาติดต่อทีม support";
          showGameResultErrorDialog.value = true;
        });
      if (gameResult.result === null) {
        resultErrorMessage.value = "ไม่พบข้อมูลเกม กรุณาติดต่อทีม Support";
        showGameResultErrorDialog.value = true;
      }
      if (gameResult.type.toLowerCase() === "url" && gameResult.result) {
        window.open(gameResult.result.url);
      }
      if (gameResult.type.toLowerCase() === "json" && gameResult.result) {
        results.value = gameResult.result;
        isShowGameResultDialog.value = true;
      }
    };

    const getProviderList = async () => {
      try {
        const { data: providerLists } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/provider/find-all`);
        providerList.value = providerLists.result
        return providerList.value
      } catch (err) {
        console.log(err)
      }
    };

    const checkHasGameResult = (moduleCode) => {
      const nonGameProviderCode = process.env.VUE_APP_NON_GAME_PROVIDER_MODULE_CODE.split(",")
      const old_condition = nonGameProviderCode.includes(moduleCode.toLowerCase())
      if (old_condition) return false;

      const provider = providerList.value.find(p => p.providerCode.toLowerCase() == moduleCode.toLowerCase())
      return provider ? provider.hasGameResult : false
    };

    const refetch = () => {
      isLoaded.value = false;
      route.query.page ? (currentPage.value = parseInt(route.query.page)) : 1;

      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/operator-admin/wallet/cms/transactions/pagination", {
          operatorId: store.state.selectedOperator.operatorId,
          userId: route.params.id,
          sortBy: [["seqNum", -1]],
          pageSize: pageConfig.value.rowsPerPage,
          page: pageConfig.value.page - 1 || parseInt(route.query.page) - 1,
          filter: {
            action: null,
            moduleCode: null,
            startDate: parseInt(route.query.from) || null,
            endDate: parseInt(route.query.to) || null,
          },
        })
        .then(({ data }) => {
          pageConfig.value.dataLength = data.result.rows.length;
          if (data.result.rows) dataRows.value = data.result.rows;
          window.history.replaceState(
            {},
            document.title,
            `?${stringify({
              page: pageConfig.value.page,
              rowsPerPage: pageConfig.value.rowsPerPage,
            })}`
          );
          isLoaded.value = true;
        })
        .catch(({ response }) => { isLoaded.value = true; });
    };

    const onSettleClicked = (data) => {
      toSettleData.value = data;
      isShowSettleDialog.value = true;
    };

    const closeSettleDialog = () => {
      toSettleData.value = {};
      reSettleValue.value = "";
      isShowSettleDialog.value = false;
    };

    const onCancelBetClicked = (data) => {
      if (confirm(`Are you sure you want to cancel bet this Game Id? (Game Id: ${data.refCode2})`)) {
        route.query.page ? (currentPage.value = parseInt(route.query.page)) : 1;
        isLoading.value = true;
        // isWorking.value = true;
        const payload = {
          requestId: `FORCECANCEL:${data.refCode}`,
          amount: data.amount,
          operatorId: store.state.selectedOperator.operatorId,
          providerCode: data.moduleCode,
          refCode: data.refCode,
          refCode2: data.refCode2,
          userId: route.params.id,
          alias: data.userdata7 || data.username || null,
        };
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/provider/game/force-cancel", payload)
          .then(({ data }) => {
            isLoading.value = false;
            // console.log(data)
            // currentPage.value = 1
            refetch();
          })
          .catch((err) => {
            isLoading.value = false;

            statusMessage.value = {
              success: false,
              message: err.response.data.message || "ไม่สามารถ cancel bet ได้ เนื่องจากเคย cancel ไปแล้ว",
            };

            isLoading.value = false;
            isShowStatusDialog.value = true;
            errorMessage.value = err.response.data.message;
          });
      }
    };

    const prev = () => {
      if (currentPage.value - 1 >= 1) {
        currentPage.value -= 1;
        offset.value = (currentPage.value - 1) * rowsPerPage.value.value;
        router.push({ query: { page: currentPage.value } });
        route.query.page = currentPage.value;
        refetch();
      }
    };

    const next = () => {
      if (pageConfig.value.dataLength < rowsPerPage.value.value) {
        return;
      }
      currentPage.value += 1;
      offset.value = rowsPerPage.value.value * currentPage.value;
      router.push({ query: { page: currentPage.value } });
      route.query.page = currentPage.value;
      refetch();
    };

    const paginationOffset = (i) => {
      const page = Math.ceil(dataCount.value / 10) >= i ? i : Math.ceil(dataCount.value / 10);
      return page;
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const forceSettle = () => {
      // isWorking.value = true;
      isLoading.value = true;
      const payload = {
        requestId: `FORCESETTLE:${toSettleData.value.refCode}`,
        amount: reSettleValue.value || 0,
        operatorId: store.state.selectedOperator.operatorId,
        providerCode: toSettleData.value.moduleCode,
        refCode: toSettleData.value.refCode,
        refCode2: toSettleData.value.refCode2,
        userId: route.params.id,
        alias: toSettleData.value.userdata7 || null,
      };
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/provider/game/force-settle", payload)
        .then(({ data }) => {
          isLoading.value = false;
          currentPage.value = 1;
          refetch();
          closeSettleDialog();
        })
        .catch((err) => {
          isLoading.value = false;
          statusMessage.value = {
            success: false,
            message: err.response.data.message || "ไม่สามารถ Resettle ได้ เนื่องจากเคย settle ไปแล้ว",
          };

          isShowStatusDialog.value = true;

          closeSettleDialog();
          errorMessage.value = err.response.data.message;
        });
    };
    watch(
      () => pageConfig.value.page,
      () => refetch()
    );
    watch(
      () => pageConfig.value.search,
      // () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = 1;
        refetch();
      }
    );
    /** fetch data when rows per page was changed */
    watch(
      () => pageConfig.value.rowsPerPage,
      () => {
        pageConfig.value.page = Number(route.query.page) || 1;
        refetch();
      }
    );

    return {
      store,
      dataRows,
      dataCount,
      isLoaded,
      route,
      dayjs,
      viewData,
      prev,
      next,
      paginationOffset,
      pages,
      forceSettle,
      refetch,
      currentPage,
      offset,
      rowsPerPageOption,
      rowsPerPage,
      isShowSettleDialog,
      onSettleClicked,
      closeSettleDialog,
      reSettleValue,
      onCancelBetClicked,
      isShowStatusDialog,
      statusMessage,
      isLoading,
      pageConfig,
      showGameResult,
      isShowGameResultDialog,
      results,
      showGameResultErrorDialog,
      resultErrorMessage,
      providerList,
      checkHasGameResult,
    };
  },
};
</script>
<style scoped>
/* Add a simple spinner style without a background color */
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1); 
  border-radius: 50%;
  border-top: 4px solid transparent; 
  width: 36px;
  height: 36px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>